export default __webpack_public_path__ + "static/media/backendicon.2deb2522.svg";